let saving = false;

const waypoint = new Waypoint.Infinite({
    element : $('.collection')[0],
    items   : '.product_card',
    onAfterPageLoad: function() {
        checkLabels();
    }
});

$(document).ready(function() {
    $('body').on('click','.popup', function() {
        $(this).remove();
        window.location.reload();
    });

    $('.collection').on('click', '.product_card .product_card_sizes span', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!saving) {
            saving = true;
            $(this).removeClass('added').addClass('loading');
            const url       = $(this).data('url');
            const variantid = $(this).data('variantid');

            const that      = $(this);
            const formData = { 'items': [{'id': variantid, 'quantity': 1 }] };
        
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(formData)
            }).then(response => {
                return response.json();
            }).then(json => {
                if (json.status === 422) {
                    console.log("ERR:", json);
                    that.removeClass('loading');
                    $('body').prepend("<div class='popup'><div class='popup_inner'><h1>Sold out</h1><p>" + json.description + "</p></div></div>");
                    saving = false;                    
                } else {
                    $.ajax({
                        url: window.location.href,
                        success: function(res) {
                            $('.header .cart_btn font').html($(res).find('.cart .cart_inner').data('items'));
                            that.removeClass('loading').addClass('added');
                            $('.cart .cart_inner').html($(res).find('.cart .cart_inner').html());
                            saving = false;
                        },
                        error: function(e) {
                            that.removeClass('loading');
                            saving = false;
                        }
                    });
                }
            }).catch((error) => {
                console.error('Error:', error);
                that.removeClass('loading');
                saving = false;
            });
        }
    });

    checkLabels();
})

const checkLabels = () => {
    const sizeArray = ['os','xs','s','m','l','xl','xxl'];
    $('.product_card').each(function(index) {
        const num = $(this).find('.product_card_sizes > span:not(.not_active):not(.long_label)').length;
        $(this).find('.product_card_sizes > span:not(.not_active)').each(function() {
            const label = $(this).find('.label').html().trim();
            if (!sizeArray.includes(label)) {
                $(this).addClass('long_label');
            }                
        })
    });
}